import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { Flask, Dna, Stethoscope, ChartLineUp, Heartbeat, Devices, UserFocus, Brain, Pulse, HandCoins } from "@phosphor-icons/react";
import { PageHeader } from "../components/PageHeader";
import { FadeUp, Overline } from "../components/Reveal";
import { SERVICES } from "../data/services";

const ICONS = { Flask, Dna, Stethoscope, ChartLineUp, Heartbeat, Devices, UserFocus, Brain, Pulse, HandCoins };

export default function Services() {
  return (
    <>
      <PageHeader
        testId="services-page"
        overline="Services"
        title={["Solutions across the", "continuum of care."]}
        subtitle="From the sequencer to the patient's phone — nine disciplines, all delivered AI-native: lean, fast, compliant, and a fraction of legacy-vendor cost."
      />
      <section className="pb-24 lg:pb-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 space-y-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <FadeUp key={s.slug} delay={i * 0.03}>
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`services-row-${s.slug}`}
                  className="group grid gap-6 lg:grid-cols-12 items-center rounded-2xl border border-primary/10 bg-white p-8 lg:p-10 transition-all duration-300 hover:-translate-y-1 hover:border-accent/50 hover:shadow-xl hover:shadow-accent/10"
                >
                  <div className="lg:col-span-1 flex items-center gap-4">
                    <span className="font-display text-sm text-primary/30">{String(i + 1).padStart(2, "0")}</span>
                    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/5 text-primary transition-colors duration-300 group-hover:bg-accent">
                      <Icon size={24} weight="duotone" />
                    </span>
                  </div>
                  <div className="lg:col-span-4">
                    <h2 className="font-display text-2xl font-medium tracking-tight text-foreground group-hover:text-primary">{s.name}</h2>
                    <p className="mt-1 text-sm text-accent font-medium">{s.tagline}</p>
                  </div>
                  <p className="lg:col-span-6 text-sm sm:text-base text-muted-foreground leading-relaxed">{s.description}</p>
                  <div className="lg:col-span-1 flex lg:justify-end">
                    <ArrowUpRight size={24} className="text-primary/20 transition-all duration-300 group-hover:text-accent group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </div>
                </Link>
              </FadeUp>
            );
          })}
        </div>
      </section>
      <section className="pb-24 lg:pb-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <FadeUp>
            <div className="rounded-3xl bg-primary p-10 lg:p-16 text-white flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
              <div>
                <Overline>Not sure where to start?</Overline>
                <h2 className="mt-4 font-display text-3xl font-medium tracking-tight">Let's map your digital maturity together.</h2>
              </div>
              <Link
                to="/demo"
                data-testid="services-demo-btn"
                className="inline-flex items-center gap-2 rounded-full bg-accent px-7 py-3.5 text-sm font-semibold text-primary transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-accent/30"
              >
                Talk to Us <ArrowUpRight size={16} weight="bold" />
              </Link>
            </div>
          </FadeUp>
        </div>
      </section>
    </>
  );
}
